import { useAuth } from "@stardeck/client-auth";
import { useCallback } from "react";

export default function useApiQuery() {
  const { session } = useAuth();

  const authenticatedFetch = useCallback(
    (...args: Parameters<typeof fetch>) => {
      return fetch(args[0], {
        ...args[1],
        headers: session?.token ? { Authorization: `Bearer ${session.token}` } : {},
      });
    },
    [session?.token]
  );

  return authenticatedFetch;
}
